<template>
  <RouterView />
</template>

<script setup>
import { useTokenStore } from '@/stores'
import { getHttpsAddress } from '@/utils/index'

const { setToken, setRefreshtoken } = useTokenStore()

onMounted(() => {
  // 获取网址中的token参数的值
  const token = new URL(window.location.href).searchParams.get('token')
  const refreshtoken = new URL(window.location.href).searchParams.get('refreshtoken')

  getHttpsAddress()

  // 林
  // const token =
  //   'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VySnNvbiI6IntcImlkXCI6NDAsXCJwbGF0Zm9ybUNvbnN0YW50XCI6XCJXRUNIQVRfUFJPR1JBTVwiLFwiZXhwaXJlc0F0XCI6MTc2Njg0MDYyMzQ3NixcInJlbWVtYmVyXCI6dHJ1ZX0iLCJleHAiOjE3NjY4NDA2MjN9.FX1P0y8azCkx7PfTrAbi3O1u0PxzFnws-8nfgGc0z0CcmrA74tf5Wx1fMaoictnIXIuuuN25D2EhJu68wPNhMw'
  // const refreshtoken = 'feca5cdbb9448e752a73f7632b3b6b8e'

  // 沈
  // const token =
  //   'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VySnNvbiI6IntcImlkXCI6MzksXCJwbGF0Zm9ybUNvbnN0YW50XCI6XCJXRUNIQVRfUFJPR1JBTVwiLFwiZXhwaXJlc0F0XCI6MTc2Njg0MDczODYwNixcInJlbWVtYmVyXCI6dHJ1ZSxcIm51bWVueElkXCI6XCJOTTAxMjUxMjI0MDAwMDEwXCJ9IiwiZXhwIjoxNzY2ODQwNzM4fQ.9js_ggtg9hAy51kQg_ib9kznBZMrrBp9B9y4-OsKWo6BwsMM3LvUrIPVGNvU_7qXpTAUzaD_Dx_aQN_ze6Dqiw'
  // const refreshtoken = '8b39aa37afccb71328cd142351eea638'
  if (token) {
    // 存储token
    localStorage.setItem('userToken', JSON.stringify({ token, refreshtoken }))
    setToken(token)
    setRefreshtoken(refreshtoken)
  }
})
</script>

<style scoped lang="scss"></style>
